/**
 * Chart palette derived from the theme tokens.
 * `cssVar(name)` returns `hsl(var(--name))` strings so charts respect light/dark.
 */
export function cssVar(name: string, alpha?: number): string {
  if (alpha != null) return `hsl(var(--${name}) / ${alpha})`;
  return `hsl(var(--${name}))`;
}

export const palette = {
  primary: () => cssVar('primary'),
  primarySoft: () => cssVar('primary', 0.18),
  border: () => cssVar('border'),
  axis: () => cssVar('muted-foreground', 0.7),
  grid: () => cssVar('border', 0.5),
  surface: () => cssVar('surface-elevated'),
  foreground: () => cssVar('foreground'),
  series: [
    () => cssVar('primary'),
    () => cssVar('info'),
    () => cssVar('success'),
    () => cssVar('warning'),
    () => cssVar('danger'),
    () => cssVar('muted-foreground'),
  ],
};
